export function installRuntimeDomGuards() {
  if (typeof window === "undefined" || typeof Node === "undefined") return;
  if (window.__runtimeDomGuardsInstalled) return;

  window.__runtimeDomGuardsInstalled = true;

  const nativeRemoveChild = Node.prototype.removeChild;

  Node.prototype.removeChild = function guardedRemoveChild<T extends Node>(this: Node, child: T): T {
    if (child && child.parentNode !== this) {
      return child;
    }

    // lib.dom's generic return loses T through Function.call, but the DOM returns this same child.
    return nativeRemoveChild.call(this, child) as T;
  };
}
